import { Typography, DialogActions } from '@mui/material';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  CustomButton,
  NoDataSkeleton,
} from '../../../../../common/components';
import CouponsDetailTable from './CouponsDetailTable';
import DifferimentTotalsTable from './DifferimentTotalsTable';
import PrintIcon from '@mui/icons-material/Print';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
  exportDifferimentDetailToExcel,
  exportDifferimentDetailToPdf,
} from '../../utils/exportDifferimentDetail';

const getCalcReferences = (coupons = []) => {
  const hasSimple = coupons.some((c) => Number(c.simple || 0) > 0);
  const hasDouble = coupons.some((c) => Number(c.double || 0) > 0);
  const hasAdequaSimple = coupons.some((c) => Number(c.adequa_simple || 0) > 0);
  const hasAdequaDouble = coupons.some((c) => Number(c.adequa_double || 0) > 0);

  const refs = [];
  if (hasAdequaSimple) refs.push('Diferimiento de adecuación simple: porcentaje / 100 * 2/3 cuotas.');
  if (hasAdequaDouble) refs.push('Diferimiento de adecuación doble: porcentaje / 100 * 4/3 cuotas.');
  if (hasSimple) refs.push('Diferimiento simple: porcentaje / 100 cuotas.');
  if (hasDouble) refs.push('Diferimiento doble: porcentaje / 100 * 2 cuotas.');
  return refs;
};

const DifferimentDetailDialog = ({ open, onClose, detail, isLoading }) => {
  const handleExportExcel = () => {
    if (!detail) return;
    exportDifferimentDetailToExcel(detail);
  };

  const handleExportPdf = () => {
    if (!detail) return;
    exportDifferimentDetailToPdf(detail);
  };

  return (
    <DialogContainer open={open} onClose={onClose} size="large">
      <DialogTitle>Detalle de diferimiento - Contrato: {detail?.contract_number}</DialogTitle>
      <DialogBody>
        {isLoading ? (
          <Typography>Cargando...</Typography>
        ) : !detail ? (
          <NoDataSkeleton />
        ) : (
          <>
            <CouponsDetailTable coupons={detail.coupons || []} />
            <DifferimentTotalsTable
              total={detail.total_differiment}
              paid={detail.paid_differiment}
              pending={detail.pending_differiment}
            />
            {getCalcReferences(detail.coupons).length > 0 && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                Referencias de cálculo
                <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 18 }}>
                  {getCalcReferences(detail.coupons).map((ref) => (
                    <li key={ref}>{ref}</li>
                  ))}
                </ul>
              </Typography>
            )}
          </>
        )}
      </DialogBody>
      <DialogActions>
        <CustomButton
          buttonIcon={FileDownloadIcon}
          onClick={handleExportExcel}
          disabled={!detail}
          variant="info"
        >
          Exportar XLSX
        </CustomButton>
        <CustomButton
          buttonIcon={PrintIcon}
          onClick={handleExportPdf}
          disabled={!detail}
          variant="info"
        >
          Exportar PDF
        </CustomButton>
        <CustomButton onClick={onClose} variant="warning">
          Cerrar
        </CustomButton>
      </DialogActions>
    </DialogContainer>
  );
};

export default DifferimentDetailDialog;
